/*
 * @Author: hippo
 * @Date: 2023-06-14 09:22:25
 * @LastEditors: hippo
 * @LastEditTime: 2023-06-14 10:50:48
 * @FilePath: /subang-console/src/models/taskHall/services.js
 * @Description: 
 * 
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved. 
 */
import api from '@/apis'

export const fetchTask = params => api.get(`/task`, { params })
export const fetchTaskCount = params => api.get(`/task/count`, { params })
export const setDeal = params => api.get(`/deal`, { params })
export const setIgnore = params => api.get(`/ignoreOrder`, { params })

